import { InputController } from '../types';
import { IBaseInputProps } from './types';

export const getBaseInputProps = (controller: InputController): IBaseInputProps => {
  return {
    onChange: (e) => controller.handleChange(e.target.value),
    onBlur: (e) => controller.handleBlur?.(e.target.value),
  };
};
